import { ContractorCardPropsType } from '..';

type StarsPropsType = Pick<ContractorCardPropsType, 'stars'>;

const Stars = ({ stars }: StarsPropsType) => {
  return (
    <div className="flex space-x-4">
      {Array.from(Array(5), (item, index) => {
        const filledStar = index < Math.floor(stars);
        const partiallyFilledStar = index < stars && index + 1 > stars;
        const partialFillPercentage = Math.round((stars % 1) * 100);
        const greenDark = '#00853f';
        const gray = '#d7d9da';
        return (
          <svg
            data-testid={`star-number-${index + 1}`}
            width={16}
            viewBox="0 0 64 64"
            xmlns="http://www.w3.org/2000/svg"
            key={`star-rating-${index}`}
          >
            <defs>
              <linearGradient id="partialStarFill" x1="0%" x2="100%" y1="0%" y2="0%">
                <stop offset="0%" stopColor={greenDark} />
                <stop offset={`${partialFillPercentage}%`} stopColor={greenDark} />
                <stop offset={`${partialFillPercentage}%`} stopColor={gray} />
                <stop offset="100%" stopColor={gray} />
              </linearGradient>
            </defs>
            <path
              fill={partiallyFilledStar ? 'url(#partialStarFill)' : filledStar ? greenDark : gray}
              d="M63.849,24.54c-.34-1.056-1.252-1.827-2.351-1.985l-18.583-2.7L34.609,3.018c-.723-1.443-2.479-2.027-3.922-1.303-.564,.282-1.021,.74-1.303,1.303l-8.323,16.836L2.478,22.554c-1.595,.246-2.689,1.738-2.443,3.334,.097,.63,.397,1.21,.855,1.654l13.437,13.103-3.177,18.504c-.189,1.096,.26,2.204,1.159,2.859,.905,.644,2.093,.73,3.081,.222l16.598-8.704,16.614,8.736c.986,.515,2.179,.429,3.081-.222,.899-.655,1.348-1.763,1.159-2.859l-3.177-18.504,13.437-13.103c.814-.782,1.104-1.963,.747-3.034Z"
            ></path>
          </svg>
        );
      })}
    </div>
  );
};

export default Stars;
